module.exports = __webpack_public_path__ + "img/12angry-4.dca9c7d1.jpg";